import React from "react";
import axios from "services/axios";
import Axios from "axios";
import { Button, Card, message, Spin, Modal, DatePicker, Tooltip } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import moment from "moment";
import momentTZ from "moment-timezone";
import _ from "lodash";
import downloadExcel from "../../../services/downloadExcel";
import ModalDetail from "./ModalDetail";

import { errorMessage } from "../../Utils";

let cancelToken;

class PriceCheckHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      priceCheckHistory: [],
      isLoading: true,
      confirmLoading: false,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
      visibleDownloadModal: false,
      disableButtonDownload: true,
      visibleModalDetail: false,
      rangeTime: [],
      priceCheckDetail: {},
    };
    this.visibleModalDetail = this.visibleModalDetail.bind(this);
  }

  componentDidMount() {
    this.fetchPriceCheckHistory(this.state.page, this.state.limit);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.role !== this.props.match.params.role) {
      this.setState(
        {
          isLoading: true,
          search: "",
          page: 1,
          limit: 15,
          sort: { name: "update", direction: "desc" },
        },
        () => this.fetchPriceCheckHistory(1, 15)
      );
    }
  }

  orderBy(sort) {
    let key = "date";
    let value = "desc";

    //Get Key
    if (sort.name === "Brand") key = "brand";
    else if (sort.name === "Tipe") key = "type";
    else if (sort.name === "Spec") key = "spec";
    else if (sort.name === "Year") key = "year";
    else if (sort.name === "Nama") key = "name";
    else if (sort.name === "Cabang") key = "branch";
    else if (sort.name === "Role") key = "role";
    else if (sort.name === "Hari/Tgl Cek Harga") key = "date";

    //Get Value
    if (sort.direction === "asc") value = "asc";
    else if (sort.direction === "desc") value = "desc";

    return `sort_by=${key}&order_by=${value}`;
  }

  async fetchPriceCheckHistory(page, limit) {
    let role = this.props.match.params.role;

    if (role) {
      const order = this.orderBy(this.state.sort);
      const query = `${order}&page=${page}&limit=${limit}&search=${
        this.state.search || ""
      }`;

      if (cancelToken) {
        cancelToken.cancel("Operation canceled due to new request");
      }
      cancelToken = Axios.CancelToken.source();

      await axios
        .get(`admin-panel/price-check-history/${role}?${query}`, {
          cancelToken: cancelToken.token,
        })
        .then(result => {
          this.setState({
            priceCheckHistory: result.data.priceCheckHistory,
            page: result.data.page,
            limit: result.data.limit,
            count: result.data.count,
            isLoading: false,
          });
        })
        .catch(err => {
          if (!Axios.isCancel(err)) {
            errorMessage(err.response || err);
            this.setState({ isLoading: false });
          }
        });
    }
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchPriceCheckHistory(page, limit);
  }

  getCar(data) {
    let car = {};

    if (data) {
      let { CarSpec } = data;

      //Year
      car = {
        ...car,
        year: data.year || null,
      };

      //Spec
      if (CarSpec) {
        let { CarType } = CarSpec;
        car.spec = CarSpec.carSpec || null;

        //Type
        if (CarType) {
          let { CarBrand } = CarType;
          car.type = CarType.carType || null;

          //Brand
          if (CarBrand) {
            car.brand = CarBrand.brand || null;
          }
        }
      }
    }
    return car;
  }

  checkData(data) {
    return data ? data : null;
  }

  onChangeDownload(date) {
    const data = momentTZ(date).tz("Asia/Jakarta").format("D MMM YYYY");
    return data;
  }

  getBranchName(role, data) {
    console.log(role);
    let branch = "";
    if (data) {
      branch = data.branch || "";
      if (role == "sales") {
        if (
          data.User &&
          data.User.SalesProfile &&
          data.User.SalesProfile.SalesBranch
        ) {
          branch = data.User.SalesProfile.SalesBranch.branch;
        }
      }
    }
    return branch;
  }

  async downloadPriceCheckHistory() {
    let { rangeTime } = this.state;
    let role = this.props.match.params.role;

    if (Array.isArray(rangeTime) && rangeTime.length == 2) {
      if (moment(rangeTime[0]).isValid() && moment(rangeTime[1]).isValid()) {
        this.setState({ confirmLoading: true });
        const data = await axios
          .post(
            `admin-panel/price-check-history/download/${role}?sort_by=date&order_by=asc`,
            { rangeTime }
          )
          .then(result => {
            if (
              result.data.priceCheckHistory &&
              result.data.priceCheckHistory.length > 0
            ) {
              const priceCheckHistory = result.data.priceCheckHistory.map(
                (item, idx) => {
                  const { brand, type, spec, year } = this.getCar(
                    item.CarPricing
                  );
                  return {
                    // no: idx + 1,
                    "Tanggal Cek Harga": momentTZ(item.createdAt)
                      .tz("Asia/Jakarta")
                      .format("D MMMM YYYY HH:mm:ss"),
                    brand,
                    type,
                    spec,
                    branch: this.getBranchName(role, item),
                    name: item.User ? item.User.name : "",
                    nrp: item.User ? item.User.nrp : "",
                    year,
                    // role: item.User ? item.User.role : "",
                  };
                }
              );
              const fileName = `History Cek Harga ${this.onChangeDownload(
                rangeTime[0]
              )} - ${this.onChangeDownload(rangeTime[1])}`;
              downloadExcel(priceCheckHistory, fileName);
              this.setState({
                visibleModalDownload: false,
              });
            } else {
              message.error("Data History Cek Harga kosong!");
            }
          })
          .catch(err => {
            if (!Axios.isCancel(err)) {
              errorMessage(err.response || err);
            }
          })
          .finally(() => {
            this.setState({ isLoading: false, confirmLoading: false });
          });
      } else message.error("Silahkan pilih tanggal terlebih dahulu!");
    } else message.error("Silahkan pilih tanggal terlebih dahulu!");
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  onChangeRange(date, dateString) {
    this.setState({
      rangeTime: dateString,
      disableButtonDownload: false,
    });
  }

  visibleModalDownload() {
    this.setState({
      visibleModalDownload: !this.state.visibleModalDownload,
    });
  }

  visibleModalDetail(status) {
    this.setState({
      visibleModalDetail: status,
    });
  }

  onClickDetailRecord(data) {
    this.setState({
      priceCheckDetail: data,
      visibleModalDetail: true,
    });
  }

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Nama",
        options: {
          sort: true,
        },
      },
      {
        name: "Role",
        options: {
          sort: true,
        },
      },
      {
        name: "Cabang",
        options: {},
      },
      {
        name: "Brand",
        options: {
          sort: true,
        },
      },
      {
        name: "Tipe",
        options: {
          sort: true,
        },
      },
      {
        name: "Spec",
        options: {
          sort: true,
        },
      },
      {
        name: "Year",
        options: {
          sort: true,
        },
      },
      {
        name: "Hari/Tgl Cek Harga",
        options: {
          sort: true,
        },
      },
    ];

    //Data New Car
    const priceCheckHistory = this.state.priceCheckHistory.map((item, idx) => {
      const { brand, type, spec, year } = this.getCar(item.CarPricing);
      return [
        <Tooltip placement="bottom" title="Detail Cek Harga">
          <Button
            onClick={() =>
              this.onClickDetailRecord({ ...item, brand, type, spec, year })
            }
            icon="bars"
            style={{ marginRight: 10 }}
          />
        </Tooltip>,
        item.User ? item.User.name : null,
        item.User ? item.User.role : null,
        item.branch,
        this.checkData(brand),
        this.checkData(type),
        this.checkData(spec),
        this.checkData(year),
        momentTZ(item.createdAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      sortOrder: this.state.sort,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Cek Harga"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <div style={{ marginBottom: 10 }}>
          <Button onClick={() => this.visibleModalDownload()}>
            Download Data
          </Button>
        </div>

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title={`Cek Harga`}
              data={priceCheckHistory}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        <Modal
          title="Download Data Cek Menu History"
          visible={this.state.visibleModalDownload}
          confirmLoading={this.state.confirmLoading}
          okButtonProps={{ disabled: this.state.disableButtonDownload }}
          onOk={() => this.downloadPriceCheckHistory()}
          onCancel={() => this.visibleModalDownload()}>
          <p>Pilih range waktu history cek harga</p>
          <DatePicker.RangePicker
            format="YYYY-MM-DD"
            onChange={(date, dateString) =>
              this.onChangeRange(date, dateString)
            }
          />
        </Modal>

        <ModalDetail
          showModalDetail={this.state.visibleModalDetail}
          priceCheck={this.state.priceCheckDetail}
          toggleModalDetail={this.visibleModalDetail}
        />
      </Card>
    );
  }
}

export default PriceCheckHistory;



// WEBPACK FOOTER //
// src/components/Dashboard/PriceCheckHistory/PriceCheckHistory.js